import axios from '../../../../utils/AxiosUtils';
import i18n from '../../../../i18next';

import {
    LOADING,
    LOAD_TENDER_TYPES_SUCCESS,
    RESET_TENDER_TYPES
} from '../../../types';
import MessageUtils from "../../../../utils/MessageUtils";

export const loadAllTenderTypes = () => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/tender-type`;

        axios().get(url)
            .then(response => loadAllTenderTypesSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:deliveryActions.loadTendersFailure')));
    }
}

const loadAllTenderTypesSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_TENDER_TYPES_SUCCESS, payload: response.data });
}

export const resetTenderTypes = () => {
    return (dispatch) => {
        dispatch({ type: RESET_TENDER_TYPES });
    }
};


// WEBPACK FOOTER //
// ./src/actions/restaurants/settings/service/TenderTypesAction.js